import type { CSSProperties } from "react";

export const mono = "'Courier New', monospace";

export const s: Record<string, CSSProperties> = {
  formbox: { border: "1.5px solid #000", padding: "14px 16px" },

  hdr: { display: "flex", alignItems: "flex-start", gap: 16 },
  flag: {
    display: "inline-flex",
    width: 32,
    height: 17,
    border: "0.5px solid #999",
    background:
      "linear-gradient(to right,#000 25%,#fff 25%,#fff 75%,#000 75%)",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    flex: "0 0 auto",
  },
  leaf: { fontSize: 14, lineHeight: 1, filter: "grayscale(1) brightness(0)" },
  crarow: { display: "flex", gap: 8, alignItems: "flex-start", fontSize: 8.5, lineHeight: 1.2 },
  craN: { width: 66, display: "inline-block" },
  yrrow: { display: "flex", alignItems: "center", gap: 8, marginTop: 8 },
  yrtext: { fontSize: 8, lineHeight: 1.25 },
  yrbox: { border: "1px solid #000", padding: "2px 10px", fontSize: 18, fontWeight: "bold" },
  yr26: { fontWeight: "normal", textDecoration: "underline", paddingLeft: 4 },
  formno: { border: "1px solid #000", padding: "4px 9px", fontWeight: "bold", fontSize: 13, marginTop: 2 },
  htitle: { textAlign: "center", fontSize: 10, lineHeight: 1.3, marginTop: 2 },
  big: { fontSize: 22, fontWeight: "bold", verticalAlign: "middle" },
  smt: { fontSize: 10, textAlign: "left", display: "inline-block", verticalAlign: "middle", marginLeft: 4 },
  hprot: { marginLeft: "auto", textAlign: "right", fontSize: 11, lineHeight: 1.35 },

  body: { display: "flex", gap: 12, marginTop: 14, alignItems: "flex-start" },
  colL: { width: "32%", display: "flex", flexDirection: "column", gap: 0 },
  colM: { flex: 1, display: "flex", flexDirection: "column", gap: 0 },
  colR: { width: 172 },
  instr: { border: "1px solid #000", padding: "9px 11px", fontSize: 10, lineHeight: 1.35, marginBottom: 14 },

  fb: { display: "flex", flexDirection: "column" },
  lbl: {
    textAlign: "center",
    fontSize: 8,
    lineHeight: 1.15,
    padding: "2px 2px",
    minHeight: 14,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  field: { border: "1px solid #000", display: "flex", alignItems: "stretch", minHeight: 26 },
  bn: {
    borderRight: "1px solid #000",
    fontWeight: "bold",
    fontSize: 9,
    padding: "2px 4px",
    display: "flex",
    alignItems: "flex-start",
  },
  val: {
    flex: 1,
    textAlign: "right",
    fontFamily: mono,
    fontSize: 13,
    padding: "3px 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  valCtr: { justifyContent: "center" },
  cents: {
    borderLeft: "1px solid #000",
    width: 34,
    textAlign: "right",
    fontFamily: mono,
    fontSize: 13,
    padding: "3px 4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  centsSh: { background: "#D9D9D9" },

  acctbox: { border: "1px solid #000", padding: "7px 9px" },
  acctlbl: { fontSize: 8, marginBottom: 3 },
  acctinner: {
    border: "1px solid #000",
    padding: "5px 8px",
    fontFamily: mono,
    fontSize: 13,
    letterSpacing: 1,
  },
  empaddr: { fontFamily: mono, fontSize: 13, lineHeight: 1.9, marginTop: 6 },

  note2: { display: "flex", gap: 24, fontSize: 8, lineHeight: 1.3, marginTop: 5, paddingLeft: 2 },

  dnu: { border: "1px solid #000", padding: "8px 9px", fontSize: 9, minHeight: "100%" },
  dnuH: { textAlign: "center", fontWeight: "bold", marginBottom: 10, lineHeight: 1.25 },
  grp: { marginBottom: 10 },
  cap: { fontSize: 8, textAlign: "center", lineHeight: 1.15, marginBottom: 3 },
  numbox: {
    border: "1px solid #000",
    fontWeight: "bold",
    fontSize: 10,
    padding: "0 4px",
    minWidth: 22,
    height: 26,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cell: {
    border: "1px solid #000",
    borderLeft: "none",
    width: 28,
    height: 26,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
  },

  diffrow: { display: "flex", marginTop: 8 },
  diffbox: { width: 210 },

  branch: { position: "relative", height: 30 },
  bbar: { position: "absolute", top: 14, left: "11%", width: "42%", borderTop: "1px solid #000" },
  bstem: { position: "absolute", top: 0, left: "53%", height: 14, borderLeft: "1px solid #000" },
  barmL: { position: "absolute", top: 14, left: "11%", height: 12, borderLeft: "1px solid #000" },
  barmR: { position: "absolute", top: 14, left: "53%", height: 12, borderLeft: "1px solid #000" },
  barwL: { position: "absolute", top: 22, left: "calc(11% - 5px)", fontSize: 12, lineHeight: 1 },
  barwR: { position: "absolute", top: 22, left: "calc(53% - 5px)", fontSize: 12, lineHeight: 1 },

  row3: { display: "flex", gap: 14, marginTop: 2 },
  c84: { width: "32%" },
  c86: { flex: 1 },
  cint: { width: 210 },

  sinrow: {
    borderTop: "1px solid #000",
    borderBottom: "1px solid #000",
    padding: "8px 2px",
    marginTop: 10,
  },
  sintop: { textAlign: "center", fontSize: 8.5 },
  sinbody: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginTop: 4,
  },

  contactrow: { display: "flex", gap: 12, marginTop: 10, alignItems: "flex-end" },
  cert: {
    borderTop: "1px solid #000",
    borderBottom: "1px solid #000",
    marginTop: 10,
    padding: "8px 2px",
  },
  certT: { textAlign: "center", fontWeight: "bold", marginBottom: 6 },
  sigrow: { display: "flex", gap: 14, marginTop: 26 },
  sig: {
    flex: 1,
    borderTop: "1px solid #000",
    paddingTop: 3,
    textAlign: "center",
    fontSize: 8.5,
  },

  foot: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: 8,
    fontSize: 9.5,
    padding: "0 2px",
  },
  cn: { fontSize: 20, fontWeight: "bold", letterSpacing: -1 },

  p2: { display: "flex", gap: 34 },
  c2: { flex: 1, fontSize: 10.5, lineHeight: 1.4 },
};